module.exports = __webpack_public_path__ + "static/media/excessFare.c582099f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/objects/other/excessFare.svg
// module id = 888
// module chunks = 0